export default __webpack_public_path__ + "02a3fbfb8113cf4439e8aff31348c8b2.png";